class MatchTargetsController {
	constructor(MatchesFactory, $rootScope, ngDialog, $filter){
		'ngInject';
		const vm = this;

		let $translate = $filter('translate');

		/* Load Matches dat */
		vm.$onInit = function(){
			vm.rootScope = $rootScope;
			vm.targetOptions = [
				{id: 1, name: 'PRODUCE_TARGETS'},
				{id: 2, name: 'EMPTY_ALL_TARGETS'},
				{id: 3, name: 'MOVE_PLAYER'},
				{id: 4, name: 'SWAP_TARGETS'},
				{id: 5, name: 'MOVE_TARGETS'},
			];
			vm.targetOptionActive = 0;
			reloadMatchData();
		};

		/* Product Targets*/
		vm.perTargetOptions = [1, 2, 3, 4];
		vm.perTarget = 4;
		vm.produceTargets = () =>{
			MatchesFactory.produceTargets(vm.rootScope.currentMatchId, vm.perTarget).then(response =>{
				ngDialog.open({template: 'successTemplate'});
				reloadMatchData();
			});
		};

		/* Clear Targets */
		vm.clearTargets = () =>{
			ngDialog.openConfirm({
				template: 'confirmTemplate',
				data: {
					message: $translate('CONFIRM_CLEAR_TARGETS'),
				},
			}).then(() =>{
				MatchesFactory.clearTargets(vm.rootScope.currentMatchId)
							  .then(response =>{
								  ngDialog.open({template: 'successTemplate'});
								  reloadMatchData();
							  });
			});
		};

		/* Move Player */
		vm.selectedPlayer = null;
		vm.target = null;
		vm.movePlayerToTarget = () =>{
			MatchesFactory.movePlayerToTarget(vm.rootScope.currentMatchId, vm.selectedPlayer.player_id, vm.target)
						  .then(response =>{
							  ngDialog.open({template: 'successTemplate'});
							  reloadMatchData();
							  vm.target = null;
							  vm.selectedPlayer = null;
						  });
		};

		/* Swap Targets */
		vm.swapTargetOne = null;
		vm.swapTargetTwo = null;
		vm.swapTargets = () =>{
			MatchesFactory.swapTargets(vm.rootScope.currentMatchId, vm.swapTargetOne.target_name, vm.swapTargetTwo.target_name)
						  .then(response =>{
							  ngDialog.open({template: 'successTemplate'});
							  reloadMatchData();
							  vm.swapTargetOne = null;
							  vm.swapTargetTwo = null;
						  });
		};

		/* Move Targets */
		vm.distance = 1;
		vm.distances = [];
		for(let i = 0; i < 21; i++){
			vm.distances.push(i);
		}
		vm.fromTarget = null;
		vm.toTarget = null;
		vm.direction = 'front';
		vm.moveTargets = () =>{
			MatchesFactory.moveTargets(vm.rootScope.currentMatchId, vm.distance, vm.fromTarget, vm.toTarget,
				vm.direction)
						  .then(response =>{
							  ngDialog.open({template: 'successTemplate'});
							  reloadMatchData();
							  vm.fromTarget = null;
							  vm.toTarget = null;
						  });
		};

		function reloadMatchData(){
			vm.matchPlayers = [];
			vm.targetNumbers = [];
			let params = {include: 'matchPlayers'};
			MatchesFactory.getOne(vm.rootScope.currentMatchId, params).then(response =>{
				vm.matchPlayers = response.data.matchPlayers;
				Object.entries(vm.matchPlayers).forEach(entry =>{
					if(entry[1].target_name == null){ return; }
					let value = entry[1].target_name.substring(0, 2);
					if(!vm.targetNumbers.includes(value)){
						vm.targetNumbers.push(value);
					}
				});
				if(vm.targetNumbers.length > 1){
					vm.targetNumbers.sort();
				}
			});
		}
	}
}

export default MatchTargetsController;



// WEBPACK FOOTER //
// ./client/app/components/matches/matchProfile/matchTargets/matchTargets.controller.js